import CollapsibleSection from 'components/CollapsibleSection';

import CoverageOptionsBody from './components/CoverageOptionsBody';
import { TEST_ID, TITLE } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const CoverageOptionsSection: FunctionComponent<Props> = ({
    className = '',
    config,
    isHomePointPickDisabled,
    isOpen,
    isPickingHomePoint,
    onConfigChange,
    onPickHomePoint,
    onToggle,
    testId = TEST_ID
}) => (
    <CollapsibleSection
        className={`${className} ${styles.coverageOptionsSection}`}
        isOpen={isOpen}
        onToggle={onToggle}
        testId={testId}
        title={TITLE}>
        <CoverageOptionsBody
            config={config}
            isHomePointPickDisabled={isHomePointPickDisabled}
            isPickingHomePoint={isPickingHomePoint}
            onConfigChange={onConfigChange}
            onPickHomePoint={onPickHomePoint}
        />
    </CollapsibleSection>
);

export default CoverageOptionsSection;
